import { render, staticRenderFns } from "./DeleteReminderModal.vue?vue&type=template&id=1cd6fb30"
import script from "./DeleteReminderModal.vue?vue&type=script&lang=js"
export * from "./DeleteReminderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports